module.exports = {"411102001":"老街街道","411102002":"马路街街道","411102003":"顺河街街道","411102004":"干河陈街道","411102100":"大刘镇","411102101":"阴阳赵镇","411102102":"空冢郭镇","411102202":"问十乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411102.json
// module id = 1624
// module chunks = 0